import { useEffect, useRef, useState } from "react";
import "./Bloqpadr.css";

const PASO_PX = 220;

const Bloqpadr = ({ padre, hijos, renderCard, onAsociarHijo }) => {
  const viewportRef = useRef(null);
  const total = hijos.length;
  const [nav, setNav] = useState({ desde: 1, hasta: 0, offIzq: true, offDer: true, overflow: false });

  const actualizar = () => {
    const vp = viewportRef.current;
    if (!vp) return;
    const visibles = Math.max(1, Math.round(vp.clientWidth / PASO_PX));
    const primero = Math.round(vp.scrollLeft / PASO_PX);
    setNav({
      desde: total === 0 ? 0 : primero + 1,
      hasta: Math.min(primero + visibles, total),
      offIzq: vp.scrollLeft <= 1,
      offDer: vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 1,
      overflow: vp.scrollWidth > vp.clientWidth + 1,
    });
  };

  useEffect(() => {
    actualizar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total]);

  const scrollPor = (dir) => {
    const vp = viewportRef.current;
    if (!vp) return;
    const visibles = Math.max(1, Math.round(vp.clientWidth / PASO_PX));
    vp.scrollBy({ left: dir * visibles * PASO_PX, behavior: "smooth" });
  };

  return (
    <div className="bp-block">
      <div className="bp-hdr">
        <span className="bp-hdr__tipo">{padre.TIPODESX}</span>
        {total > 0 ? (
          <span className="bp-hdr__count">
            {total} hijo{total > 1 ? "s" : ""}
          </span>
        ) : (
          <span className="bp-hdr__noh">Sin hijos</span>
        )}
        {nav.overflow && (
          <span className="bp-hdr__nav">
            {nav.desde} – {nav.hasta} de {total}
          </span>
        )}
        {onAsociarHijo && (
          <button
            type="button"
            className="bp-asociar"
            onClick={() => onAsociarHijo(padre)}
            title="Asociar documento hijo"
          >
            + Asociar hijo
          </button>
        )}
      </div>

      <div className="bp-row">
        <div className="bp-padre">{renderCard(padre)}</div>

        <div className="bp-sep">
          <span className="bp-sep__lbl">Hijos</span>
        </div>

        {total === 0 ? (
          <div className="bp-hijos">
            <div
              className={`bp-nohijo ${onAsociarHijo ? "bp-nohijo--click" : ""}`}
              onClick={onAsociarHijo ? () => onAsociarHijo(padre) : undefined}
            >
              {onAsociarHijo ? "Sin documentos hijos · Toca para asociar" : "Sin documentos hijos"}
            </div>
          </div>
        ) : (
          <div className="bp-hijos">
            {nav.overflow && (
              <button
                type="button"
                className={`bp-arrow ${nav.offIzq ? "bp-arrow--off" : ""}`}
                onClick={() => scrollPor(-1)}
                title="Anterior"
                disabled={nav.offIzq}
              >
                ‹
              </button>
            )}
            <div className="bp-viewport" ref={viewportRef} onScroll={actualizar}>
              <div className="bp-track">
                {hijos.map((hijo) => (
                  <div className="bp-hijo" key={hijo.IDARCHXX}>
                    {renderCard(hijo)}
                  </div>
                ))}
                {onAsociarHijo && (
                  <button
                    type="button"
                    className="bp-add-end"
                    onClick={() => onAsociarHijo(padre)}
                    title="Asociar documento hijo"
                  >
                    +
                  </button>
                )}
              </div>
            </div>
            {nav.overflow && (
              <button
                type="button"
                className={`bp-arrow ${nav.offDer ? "bp-arrow--off" : ""}`}
                onClick={() => scrollPor(1)}
                title="Siguiente"
                disabled={nav.offDer}
              >
                ›
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Bloqpadr;
